import moment from 'moment'

const curr = new Date()

export function getCurrYear() {
  return curr.getFullYear()
}

export function getCurrMonth() {
  return curr.getMonth() + 1
}

export function getCurrDate() {
  return curr.getDate()
}

export function getCurrFullDate() {
  return `${curr.getFullYear()}. ${curr.getMonth() + 1}. ${curr.getDate()}`
}

export const monthList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

export const dayList = Array.from({ length: 31 }, (v, i) => i + 1)

export const getCurrDateString = () => {
  return moment().format('YYYYMMDD')
}

export const getYMFromRange = (range) => {
  const now = new Date()
  let targetDate = new Date(now)

  if (range === '1Y') {
    targetDate.setFullYear(now.getFullYear() - 1)
  } else if (range === '6M') {
    targetDate.setMonth(now.getMonth() - 6)
  } else if (range === '3M') {
    targetDate.setMonth(now.getMonth() - 3)
  }

  const year = targetDate.getFullYear()
  const month = targetDate.getMonth() + 1 // 0~11이므로 +1

  // yyyymm 형식으로 리턴 (예: '202401')
  return `${year}${month.toString().padStart(2, '0')}`
}
